import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { filter as _filter } from 'lodash';
import { Subject } from 'rxjs';
import { filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { School } from '../models/School';
import { User } from '../models/User';
import { FeatureFlagService, FLAGS } from '../services/feature-flag.service';
import { HttpService } from '../services/http-service';
import { ScreenService } from '../services/screen.service';
import { UserService } from '../services/user.service';

const DEFAULT_NAVBAR_HEIGHT = '74px';
const HIDDEN_NAVBAR_HEIGHT = '0px';

@Component({
	selector: 'sp-dev-playground',
	templateUrl: './dev-playground.component.html',
	styleUrls: ['./dev-playground.component.scss'],
})
export class DevPlaygroundComponent implements OnInit, OnDestroy {
	user: User;
	isStaff: boolean;
	isStudent: boolean;
	navbarHeight = DEFAULT_NAVBAR_HEIGHT;
	schools: School[] = [];

	schedulesFF = false;

	private destroy$: Subject<any> = new Subject<any>();

	constructor(
		public userService: UserService,
		public screenService: ScreenService,
		public featureFlagService: FeatureFlagService,
		private http: HttpService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.http.schoolsCollection$
			.pipe(
				takeUntil(this.destroy$),
				map((schools) => {
					return _filter(schools, (school) => school.my_roles.length > 0);
				})
			)
			.subscribe((schools) => {
				this.schools = schools;
				this.schedulesFF = this.featureFlagService.isFeatureEnabledV2(FLAGS.Schedules);
			});
		this.http.globalReload$
			.pipe(
				takeUntil(this.destroy$),
				switchMap(() => {
					return this.userService.userJSON$.pipe(
						filter((u) => !!u),
						take(1)
					);
				}),
				map((user) => User.fromJSON(user)),
				switchMap((user) => {
					this.user = user;
					this.isStaff = user.isTeacher() || user.isAdmin() || user.isAssistant();
					this.isStudent = user.isStudent();
					this.navbarHeight = this.currentNavbarHeight();
					return this.userService.effectiveUser$;
				})
			)
			.subscribe();
	}

	private currentNavbarHeight(): string {
		const { url } = this.router;
		if (url.includes('kioskMode')) {
			return DEFAULT_NAVBAR_HEIGHT;
		}

		return (url === '/main/hallmonitor' && this.screenService.isDeviceLargeExtra) || (url === '/main/myroom' && this.screenService.isDeviceLargeExtra)
			? HIDDEN_NAVBAR_HEIGHT
			: DEFAULT_NAVBAR_HEIGHT;
	}

	ngOnDestroy(): void {
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}
}
